import { render, staticRenderFns } from "./wxpricebatchupdate.vue?vue&type=template&id=9fc9a560&scoped=true&"
import script from "./wxpricebatchupdate.vue?vue&type=script&lang=js&"
export * from "./wxpricebatchupdate.vue?vue&type=script&lang=js&"
import style0 from "./wxpricebatchupdate.vue?vue&type=style&index=0&id=9fc9a560&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc9a560",
  null
  
)

export default component.exports